import { Button, Modal } from '@morressier/alembic';
import { IOrganizationForm } from '../../UserRegistrationSteps/StepThree/signupHook';
import { FormProvider, useForm } from 'react-hook-form';
import { Box, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd } from '@fortawesome/pro-regular-svg-icons';
import MultipleAffiliationForm from '../../UserRegistrationSteps/StepTwo/MultipleAffiliationForm';

const UpdateSecondaryAffiliationModal = ({
  isOpen,
  onClose,
  onAdd,
  additionalAffiliations,
  configs,
  handleAffiliationDuplicateCheck,
  affiliationDetails
}: {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (affiliation: IOrganizationForm[]) => void;
  additionalAffiliations: IOrganizationForm[];
  affiliationDetails: IOrganizationForm;
  configs: any;
  handleAffiliationDuplicateCheck: (
    additionalAffiliations: IOrganizationForm[],
    affiliationDetails: IOrganizationForm
  ) => boolean;
}) => {
  const newConfig = {
    streetAddress: configs.StreetAddress,
    city: configs.City,
    stateOrRegion: configs.StateOrRegion,
    postalCode: configs.PostalCode,
    country: configs.Country,
    url: configs.Url,
    department: configs.Department,
    organizationName: configs.OrganizationName
  };

  const methods = useForm<{
    additionalAffiliations: IOrganizationForm[];
  }>({
    mode: 'onChange',
    defaultValues: {
      additionalAffiliations: additionalAffiliations || []
    }
  });
  const { handleSubmit, watch } = methods;

  const secondaryAffiliation = watch('additionalAffiliations');

  const onSubmit = () => {
    const isDuplicateFound = handleAffiliationDuplicateCheck(
      secondaryAffiliation,
      affiliationDetails
    );

    if (isDuplicateFound) {
      return;
    }
    onAdd(secondaryAffiliation);
  };

  return (
    <Modal
      isOpen={isOpen}
      width="700px"
      onClose={onClose}
      closeButtonProps={{
        visibility: 'hidden'
      }}
    >
      <Box>
        <FormProvider {...methods}>
          <form>
            <Flex direction="column" px={8} pt={8} gap={3}>
              <Box>
                <FontAwesomeIcon icon={faAdd} size="2xl" />
              </Box>
              <Text textStyle="headingGroup">Add Secondary Affiliation</Text>
              <MultipleAffiliationForm
                formConfig={newConfig}
                additionalAffiliations={additionalAffiliations}
              />
              <Flex justify="flex-end" gap={3} my={5}>
                <Button variant="secondary" onClick={onClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit(onSubmit)}>
                  Add Secondary Affiliation
                </Button>
              </Flex>
            </Flex>
          </form>
        </FormProvider>
      </Box>
    </Modal>
  );
};

export default UpdateSecondaryAffiliationModal;
